exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1pyLI{position:relative;text-decoration:none;color:#000;font-size:15px;display:block;padding:0;font-weight:400;line-height:32px;white-space:nowrap;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;cursor:pointer}._1pyLI:hover{color:#e73232}._2DBKE{font-size:13px;color:rgba(0,0,0,.3)}._12OGJ{display:none}", ""]);

// exports
exports.locals = {
	"root": "_1pyLI",
	"count": "_2DBKE",
	"displayNone": "_12OGJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/PopularMarksModels/Item/Item.css
// module id = 2258
// module chunks = 1 15 20